// extracted by mini-css-extract-plugin
export var firstLineTextRead = "ESO13";
export var firstLineTextUnread = "JBWmn";
export var mclFirstLineTextUnread = "DOWm0";